import { Dispatch } from "react";
import {Types} from "./PerformanceEvaluationContext"

export const createPerformanceEvaluationModal = (_id = "",item=null, modalPerformanceEvaluation = true , dispatch: Dispatch<any>):void =>{
    dispatch({
       type:Types.CREATE_PERFORMANCE_EVALUATION,
       payload:{
        _id,
        item,
        modalPerformanceEvaluation
       } 
    })
}

export const closePerformanceEvaluationModal = (_id="", item=null, modalPerformanceEvaluation = false, dispatch: Dispatch<any>):void => {
    console.log(item)
    dispatch({
        type: Types.CLOSE_PERFORMANCE_EVALUATION,
        payload: {
            _id,
            item,
            modalPerformanceEvaluation
        }
    })
}

export const eliminaPerformanceEvaluationModal = (_id = "", modalEliminaPerformanceEvaluation = true , dispatch: Dispatch<any>):void =>{
    dispatch({
       type:Types.DELETE_PERFORMANCE_EVALUATION,
       payload:{
        _id,
        modalEliminaPerformanceEvaluation
       } 
    })
}

export const closeEliminaPerformanceEvaluationModal = (_id="", modalEliminaPerformanceEvaluation = false, dispatch: Dispatch<any>):void => {
    dispatch({
        type: Types.CLOSE_DELETE_PERFORMANCE_EVALUATION,
        payload: {
            _id,
            modalEliminaPerformanceEvaluation
        }
    })
}

export const createCompetenceEvaluationModal = ({_id="", modalCompetenceEvaluation = true}:any, dispatch: Dispatch<any>):void => {
    dispatch({
        type: Types.CREATE_COMPETENCE_EVALUATION,
        payload: {
            _id,
            modalCompetenceEvaluation
        }
    })
}

export const closeCompetenceEvaluationModal = (_id="", modalCompetenceEvaluation = false, dispatch: Dispatch<any>):void => {
    dispatch({
        type: Types.CLOSE_COMPETENCE_EVALUATION,
        payload: {
            _id,
            modalCompetenceEvaluation
        }
    })
}

export const eliminaCompetenceEvaluationModal = ({_id = "", eliminaCompetencePerformanceEvaluation = true}:any , dispatch: Dispatch<any>):void =>{
    dispatch({
       type:Types.DELETE_COMPETENCE_EVALUATION,
       payload:{
        _id,
        eliminaCompetencePerformanceEvaluation
       } 
    })
}

export const CloseeliminaCompetenceEvaluationModal = (_id="", eliminaCompetencePerformanceEvaluation = false, dispatch: Dispatch<any>):void => {
    dispatch({
        type: Types.CLOSE_DELETE_COMPETENVE_EVALUATION,
        payload: {
            _id,
            eliminaCompetencePerformanceEvaluation
        }
    })
}

export const createEvaluationModelModal = (_id="", modalEvaluationModel = true, dispatch: Dispatch<any>):void => {
    dispatch({
        type: Types.CREATE_EVALUATION_MODEL,
        payload: {
            _id,
            modalEvaluationModel
        }
    })
}

export const closeEvaluationModelModal = (_id="", modalEvaluationModel = false, dispatch: Dispatch<any>):void => {
    dispatch({
        type: Types.CLOSE_EVALUATION_MODEL,
        payload: {
            _id,
            modalEvaluationModel
        }
    })
}

export const eliminaEvaluationModel = (_id="", eliminaModelEvaluation = true, dispatch: Dispatch<any>):void => {
    dispatch({
        type: Types.DELETE_EVALUATION_MODEL,
        payload: {
            _id,
            eliminaModelEvaluation
        }
    })
}

export const closeEliminaEvaluationModel = (_id="", eliminaModelEvaluation = false, dispatch: Dispatch<any>):void => {
    dispatch({
        type: Types.CLOSE_DELETE_EVALUATION_MODEL,
        payload: {
            _id,
            eliminaModelEvaluation
        }
    })
}

export const openCollaboratoPerformanceEvaluationModal = (_id = "",reload=false,modalCollaboratorPerformanceEvaluation = true , dispatch: Dispatch<any>):void =>{
    dispatch({
       type:Types.OPEN_COLLABORATOR_PERFORMANCE_EVALUATION,
       payload:{
        _id,
        reload,
        modalCollaboratorPerformanceEvaluation
       } 
    })
}

export const closeCollaboratoPerformanceEvaluationModal = (_id="", reload=false,modalCollaboratorPerformanceEvaluation = false, dispatch: Dispatch<any>):void => {
    dispatch({
        type: Types.CLOSE_COLLABORATOR_PERFORMANCE_EVALUATION,
        payload: {
            _id,
            reload,
            modalCollaboratorPerformanceEvaluation
        }
    })
}

export const openColExtPerfEvalModal = (_id = "",idUser=0, typeEval='',typeArray='',infoEvalExt=null, modalCollaboratorExternoPerformanceEvaluation = true , dispatch: Dispatch<any>):void =>{
    dispatch({
       type:Types.OPEN_COLLABORATOR_EXTERN_PERFORMANCE_EVALUATION,
       payload:{
        _id,
        idUser,
        typeEval,
        typeArray,
        infoEvalExt,
        modalCollaboratorExternoPerformanceEvaluation
       } 
    })
}

export const closeColExtPerEvalModal = (_id="",infoEvalExt=null, modalCollaboratorExternoPerformanceEvaluation = false, dispatch: Dispatch<any>):void => {
    dispatch({
        type: Types.CLOSE_COLLABORATOR_EXTERN_PERFORMANCE_EVALUATION,
        payload: {
            _id,
            infoEvalExt,
            modalCollaboratorExternoPerformanceEvaluation
        }
    })
}

export const openColAddPerfEvalModal = (_id = "", modalCollaboratorAddPerformanceEvaluation = true , dispatch: Dispatch<any>):void =>{
    dispatch({
       type:Types.OPEN_COLLABORATOR_ADD_PERFORMANCE_EVALUATION,
       payload:{
        _id,
        modalCollaboratorAddPerformanceEvaluation
       } 
    })
}

export const closeColAddPerEvalModal = (_id="", modalCollaboratorAddPerformanceEvaluation = false, dispatch: Dispatch<any>):void => {
     dispatch({
        type: Types.CLOSE_COLLABORATOR_ADD_PERFORMANCE_EVALUATION,
        payload: {
            _id,
            modalCollaboratorAddPerformanceEvaluation
        }
    })
}
